import { InputWithLabel } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const WeightFilter = ({ valueGte, onChangeGte, valueLte, onChangeLte }) => {
  return (
    <Styles.Container>
      <InputWithLabel
        label="Min"
        fullWidth
        endAdornment="gr"
        value={valueGte}
        onChange={e => onChangeGte(e.target.value)}
      />
      <span>-</span>
      <InputWithLabel
        label="Max"
        fullWidth
        endAdornment="gr"
        value={valueLte}
        onChange={e => onChangeLte(e.target.value)}
      />
    </Styles.Container>
  )
}

export default WeightFilter
